import React, { memo } from "react"
import { NavLink, useLocation, useParams } from "react-router-dom"
import { oldRoutes } from "router/old-routes"
import { Button, Flex } from "antd"
import { Dropdown, DropdownItem } from "components/common/Dropdown"
import { DropdownToggle } from "reactstrap"
import Icon from "components/common/Icon"

import { useTranslation } from "react-i18next"
import useActiveGuide from "hooks/useActiveClient"
import { usePermissions } from "hooks/usePermissions"
import { MODULES, ACTIONS } from "utils/permissions"
import styles from "./Header.module.css"

function Header() {
  const { t } = useTranslation()
  const params = useParams()
  const location = useLocation()
  const { isActive, isPending } = useActiveGuide()
  const { hasPermission } = usePermissions()
  const isAllowedToCreateCampaign = hasPermission(MODULES.MARKETING, ACTIONS.CREATE)

  const pages = {
    [oldRoutes.guideMarketingTemplatesPath()]: "templates",
    [oldRoutes.guideMarketingPath()]: "feeder",
    [oldRoutes.guideMarketingPostNewPath()]: "feeder",
    [oldRoutes.guideMarketingPostEditPath(params)]: "feeder"
  }

  const activePage = pages[location.pathname]
  const isFeederPage = activePage === "feeder"
  const isActionEnabled = isActive && !isPending

  const actionHref = isFeederPage ? oldRoutes.guideMarketingPostNewPath() : oldRoutes.guideMarketingTemplatesParentsPath()
  const addButtonHref = isActionEnabled ? actionHref : undefined

  return (
    <div className={styles.stickyHeader}>
      <Flex align="center" wrap className={styles.headerInner}>
        <Flex align="center" gap="large" className={styles.leftGroup}>
          <h3 className={styles.title}>{t("marketing.marketing")}</h3>
          <Dropdown
            className={styles.dropdown}
            toggleButton={
              <DropdownToggle tag="span">
                <Button
                  className={styles.toggleButton}
                  variant="outlined"
                  color="primary"
                >
                  <Flex align="center" gap="small">
                    <span>{t(`marketing.${activePage}`)}</span>
                    <Icon iconName="SidebarToggle" size={14} />
                  </Flex>
                </Button>
              </DropdownToggle>
            }
          >
            <DropdownItem tag={NavLink} to={oldRoutes.guideMarketingPath()} end>
              {t("marketing.feeder")}
            </DropdownItem>
            <DropdownItem tag={NavLink} to={oldRoutes.guideMarketingTemplatesPath()}>
              {t("marketing.templates")}
            </DropdownItem>
          </Dropdown>
        </Flex>

        {isAllowedToCreateCampaign && (
          <Button
            className={styles.addButton}
            type="primary"
            onClick={() => { window.location.href = `#${addButtonHref}` }} // NOSONAR
            disabled={!isActionEnabled}
          >
            {isFeederPage ? t("posts.add_new") : t("marketing.create_template")}
          </Button>
        )}
      </Flex>
    </div>
  )
}

export default memo(Header)
